const List = ({ children }) => {
  return <div className="w-[1200px] mx-auto">{children}</div>;
};

export default List;
